import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { GuardCode } from "../../components/GuardCode";
import Tooltip from "rc-tooltip";
import { industrys } from "./themeData.js";

import {
  Card,
  Checkbox,
  GuardButton,
  GuardUi,
  Radio,
  Switch,
} from "./component-ui";
import { ColorSelect } from "../../components/ColorSelect";
import { GuardMobile } from "./guard-mobile";

export const HomePageGuard = () => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(industrys[0]);
  const [color, setColor] = useState("#ECEDF2");
  const [code, setCode] = useState(false);
  const GuardPcRenader = () => {
    return (
      <div className="home-page-guard-warp">
        <div className="home-page-guard-warp-top">
          <div className="guard-top-title">
            {t("homePage.guard.guard-ui.title")}
          </div>
          <a
            className="guard-top-doc"
            target="_blank"
            rel="noopener noreferrer"
            href="https://docs.authing.cn/v2/reference/guard/v2/"
          >
            <span>{t("homePage.guard.guard-ui.doc")}</span>
            <i className="icon authing-icon authing-arrow-right-s-line"></i>
          </a>
        </div>
        <div className="home-page-guard-warp-inner">
          <div className="home-page-guard-left">
            <Card title={t("homePage.guard.guard-ui.left.baseSetting")} unvalid>
              <div className="guard-item">
                <Switch label={t("homePage.guard.guard-ui.left.password")} />
              </div>
              <div className="guard-item">
                <Switch
                  label={t("homePage.guard.guard-ui.left.companyAccount")}
                />
              </div>
              <div className="guard-item">
                <Switch
                  label={t("homePage.guard.guard-ui.left.socialAccount")}
                />
              </div>
            </Card>
            <Card
              title={t("homePage.guard.guard-ui.left.funcSetting")}
              unvalid
              className={"home-page-guard-left-second-height"}
            >
              <div className="guard-item">
                <span>{t("homePage.guard.guard-ui.left.loginProtal")}</span>
                <div className="guard-item-add">
                  + {t("homePage.guard.guard-ui.left.add")}
                </div>
              </div>
              <div className="guard-item">
                {t("homePage.guard.guard-ui.left.loginAdd")}
              </div>
              <div className="guard-item-descript">
                {t("homePage.guard.guard-ui.left.loginAddSub")}
              </div>
              <div className="guard-item info-top">
                <Checkbox
                  checked
                  label={t("homePage.guard.guard-ui.left.loginInfo")}
                />
              </div>
              <div className="guard-item  info-second">
                <Checkbox
                  label={t("homePage.guard.guard-ui.left.resignInfo")}
                />
              </div>
            </Card>
          </div>

          <div className="home-page-guard-center" style={{ background: color }}>
            <GuardUi theme={theme} />
          </div>

          <div className="home-page-guard-right">
            <div className="code-function-exchange">
              <div
                className={!code ? "checked guard-button" : "guard-button"}
                onClick={() => setCode(false)}
              >
                {t("homePage.guard.guard-ui.right.code")}
              </div>
              <div
                className={code ? "checked guard-button" : "guard-button"}
                onClick={() => setCode(true)}
              >
                {t("homePage.guard.guard-ui.right.css")}
              </div>
            </div>
            {code ? (
              <Card>
                <GuardCode color={color} theme={theme} />
              </Card>
            ) : (
              <div className="guard-right-warp">
                <Card
                  title={t("homePage.guard.guard-ui.right.backgorund")}
                  className="guard-right-warp-card-bottom"
                >
                  <div className="guard-item">
                    <label style={{ cursor: "pointer" }}>
                      <Radio
                        checked
                        label={t("homePage.guard.guard-ui.right.color")}
                      />
                    </label>
                    <label style={{ cursor: "not-allowed" }}>
                      <div>
                        <Radio
                          label={t("homePage.guard.guard-ui.right.picture")}
                        />
                      </div>
                    </label>
                  </div>
                  <ColorSelect color={color} setColor={setColor} />
                </Card>
                <Card
                  title={t("homePage.guard.guard-ui.right.icon")}
                  unvalid
                  className="guard-icon-warp-top"
                >
                  <div className="guard-icon-warp">
                    <div className="guard-icon">
                      <i
                        className={`icon website-icon ${theme.icon}`}
                        style={{ fontSize: 28, color: theme.color }}
                      ></i>
                    </div>
                    <div className="guard-icon-button">
                      <i
                        className="icon website-icon website-upload-cloud-2-line"
                        style={{ marginRight: 6 }}
                      ></i>
                      <span>{t("homePage.guard.guard-ui.right.upload")}</span>
                    </div>
                  </div>
                </Card>
                <Card
                  title={t("homePage.guard.guard-ui.right.language")}
                  unvalid
                >
                  <div className="guard-item">
                    <Switch label={t("homePage.guard.guard-ui.right.switch")} />
                  </div>
                  <div className="guard-item">
                    <div style={{ flex: "0 0 60px" }}>
                      {t("homePage.guard.guard-ui.right.default")}
                    </div>
                    <div className="system-button">
                      <label>
                        {t("homePage.guard.guard-ui.right.system")}
                        <i className="icon authing-icon authing-arrow-right-s-line icon-style"></i>
                      </label>
                    </div>
                  </div>
                </Card>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="home-page-guard">
      <div className="home-page-guard-title basic-title">
        {t("homePage.guard.title")}
      </div>
      <div className="home-page-guard-subtitle basic-title-desc">
        {t("homePage.guard.subtitle")}
      </div>
      <div className="basic-column">
        {GuardPcRenader()}
        <GuardButton
          color={color}
          theme={theme}
          setTheme={setTheme}
          setColor={setColor}
        />
        <GuardMobile color={color} theme={theme} setColor={setColor} />
      </div>
    </div>
  );
};
